if (!customElements.get('collection-tabs')) {
  customElements.define(
    'collection-tabs',
    class CollectionTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.list = this.querySelector('[role="tablist"]');
        this.indicator = this.querySelector('.collection-tabs__indicator');
        this.accent = this.querySelector('[data-title-accent]');

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.select(tab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event));
        });

        if (this.list && this.indicator) {
          // Tab widths change when fonts load and on resize; keep the indicator aligned.
          this.resizeObserver = new ResizeObserver(() => this.moveIndicator());
          this.resizeObserver.observe(this.list);
          this.moveIndicator();
          this.classList.add('is-ready');
        }
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      get selectedTab() {
        return (
          this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0]
        );
      }

      select(tab) {
        if (tab === this.selectedTab) return;

        this.tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', selected);
          item.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) {
            panel.hidden = !selected;
            if (selected) {
              const tmpl = panel.querySelector('template');
              if (tmpl) {
                panel.appendChild(tmpl.content);
                tmpl.remove();
                const sliderComponent = panel.querySelector('slider-component');
                if (sliderComponent && typeof sliderComponent.resetPages === 'function') {
                  sliderComponent.resetPages();
                }
              }
            }
          }
        });

        this.moveIndicator();
        this.scrollTabIntoView(tab);
        this.updateAccent(tab);
      }

      moveIndicator() {
        const tab = this.selectedTab;
        if (!this.indicator || !tab) return;
        this.indicator.style.setProperty('--indicator-left', `${tab.offsetLeft}px`);
        this.indicator.style.setProperty('--indicator-width', `${tab.offsetWidth}px`);
      }

      scrollTabIntoView(tab) {
        if (this.list.scrollWidth <= this.list.clientWidth) return;
        this.list.scrollTo({
          left: tab.offsetLeft - (this.list.clientWidth - tab.offsetWidth) / 2,
          behavior: 'smooth',
        });
      }

      updateAccent(tab) {
        if (!this.accent) return;
        this.accent.textContent = tab.textContent.trim();
        // Restart the entrance animation on every switch.
        this.accent.classList.remove('is-swapping');
        void this.accent.offsetWidth;
        this.accent.classList.add('is-swapping');
      }

      onKeydown(event) {
        const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
        if (!step) return;
        const index =
          (this.tabs.indexOf(event.currentTarget) + step + this.tabs.length) % this.tabs.length;
        this.tabs[index].focus();
        this.select(this.tabs[index]);
      }
    },
  );
}
